import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import WorkItemService from "../../services/workitemService";
import Breadcrumb from "../../components/Breadcrumb";
import StorageService from "../../services/StorageService";
import MessageDialog from "../../components/MessageDialog";
import ProjectCategoryService from "../../services/ProjectCategoryService";
import UomService from "../../services/UomService";


export default function AddWorkItem() {

    const { register, handleSubmit, setValue } = useForm();

    const navigate = useNavigate();
    const { id } = useParams();

    const [isEdit, setIsEdit] = useState(false);
    const [editLoading, setEditLoading] = useState(false);
    const [loading, setLoading] = useState(false);

    const [projectCategories, setProjectCategories] = useState([]);
    const [uoms, setUoms] = useState([]);

    const [activities, setActivities] = useState([
        {
            sqNo: 1,
            workActivityName: "",
            uom: "",
            isActive: true
        }
    ]);

    const [message, setMessage] = useState("");
    const [msgType, setMsgType] = useState("");

    // const messageTimer = useRef(null);

    const showMessage = (text, type = "error") => {
        setMessage(text);
        setMsgType(type);

        // if (messageTimer.current) clearTimeout(messageTimer.current);

        // messageTimer.current = setTimeout(() => {
        //     setMessage("");
        // }, 4000);
    };

    // const closeMessage = () => {
    //     setMessage("");
    // };


    const loadProjectCategories = async () => {

        try {

            const res =
                await ProjectCategoryService.getActive();

            console.log("PROJECT CATEGORY", res);

            setProjectCategories(
                res?.data || []
            );

        } catch (err) {

            console.error(err);

            setProjectCategories([]);
        }
    };

    const loadUoms = async () => {
        try {
            const res = await UomService.getActive();
            setUoms(res.data || res);
        } catch (err) {
            console.error(err);
            setUoms([]);
        }
    };

    const renumberSqNos = (items) => {
        return items.map((item, index) => ({
            ...item,
            sqNo: index + 1
        }));
    };

    // const addRow = () => {

    //     setActivities([
    //         ...activities,
    //         {
    //             sqNo: activities.length + 1,
    //             workActivityName: "",
    //             uom: "",
    //             isActive: true
    //         }
    //     ]);
    // };

    const addRow = () => {

        const updated = [
            ...activities,
            {
                sqNo: activities.length + 1,
                workActivityName: "",
                uom: "",
                isActive: true
            }
        ];

        setActivities(updated);
    };

    // const deleteRow = (index) => {

    //     const updated = [...activities];

    //     updated.splice(index, 1);

    //     setActivities(updated);
    // };

    const deleteRow = (index) => {

        const updated = activities.filter((_, i) => i !== index);

        setActivities(renumberSqNos(updated));
    };

    // const handleActivityChange = (index, value) => {

    //     const updated = [...activities];

    //     updated[index].workActivityName = value;

    //     setActivities(updated);
    // };

    const handleActivityChange = (index, field, value) => {
        const updated = [...activities];

        updated[index][field] = value;

        setActivities(updated);
    };

    const onSubmit = async (data) => {

        setLoading(true);

        try {

            // data.workActivities = activities.map(a => ({
            //     sqNo: Number(a.sqNo),
            //     workActivityName: a.workActivityName,
            //     uom: a.uom,
            //     status: a.isActive ? "Active" : "Inactive",
            //     createdBy: Number(
            //         StorageService.loginData().employeeId
            //     )

            const orderedActivities = renumberSqNos(
                [...activities].sort((a, b) => Number(a.sqNo) - Number(b.sqNo))
            );

            data.workActivities = orderedActivities.map(a => ({
                sqNo: Number(a.sqNo),
                workActivityName: a.workActivityName,
                uom: a.uom,
                status: a.isActive ? "Active" : "Inactive",
                createdBy: Number(StorageService.loginData().employeeId)
            }));
            // }));

            if (isEdit) {

                data.updatedBy = StorageService.loginData().employeeId;

                await WorkItemService.update(id, data);

                showMessage("Work Item updated successfully", "success");

            } else {

                // data.createdBy = StorageService.loginData().employeeId;
                data.createdBy = Number(StorageService.loginData().employeeId);

                await WorkItemService.save(data);

                showMessage("Work Item added successfully", "success");

            }

            setTimeout(() => {
                navigate("/cpnl/workitems/view", { state: { refresh: true } });
            }, 1000);

        } catch (err) {

            const backendMsg =
                err?.response?.data?.message || err?.message || "Error saving work item";

            showMessage(backendMsg, "error");

        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {

        loadProjectCategories();
        loadUoms();


    }, []);

    useEffect(() => {

        if (!id) return;

        setIsEdit(true);

        const fetchData = async () => {

            setEditLoading(true);

            try {

                const res = await WorkItemService.getById(id);

                const record = res?.data || res;

                setValue("projectCategoryId", record.projectCategoryId || "");
                setValue("workItemCode", record.workItemCode || "");
                setValue("workItemDescription", record.workItemDescription || "");

                if (
                    Array.isArray(record.workActivities) &&
                    record.workActivities.length > 0
                ) {

                    // setActivities(

                    //     record.workActivities.map(a => ({
                    //         sqNo: a.sqNo,
                    //         workActivityName:
                    //             a.workActivityName,
                    //         uom: a.uom || "",
                    //         isActive: a.status === "Active"
                    //     }))
                    // );

                    const loadedActivities = record.workActivities
                        .map(a => ({
                            sqNo: a.sqNo,
                            workActivityName: a.workActivityName,
                            uom: a.uom || "",
                            isActive: a.status === "Active"
                        }))
                        .sort((a, b) => Number(a.sqNo) - Number(b.sqNo));

                    setActivities(renumberSqNos(loadedActivities));
                }


            } catch (err) {

                showMessage("Error fetching Work Item", "error");


            } finally {
                setEditLoading(false);
            }
        };

        fetchData();

    }, [id, setValue]);

    return (
        <>
            <Breadcrumb
                pageTitle={isEdit ? "Modify Work Item" : "Add Work Item"}
                secondTitle="Masters"
            />

            {/* {message && (
                <div
                    className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
                        } d-flex justify-content-between align-items-center mb-3`}
                >
                    <span>{message}</span>
                    <button className="btn-close" onClick={closeMessage}></button>
                </div>
            )} */}


            <MessageDialog
                message={message}
                type={msgType}
                setMessage={setMessage}
                setMsgType={setMsgType}
            />


            <div className="row">
                <div className="card py-3">

                    {editLoading ? (
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary"></div>
                            <div>Loading...</div>
                        </div>
                    ) : (

                        <form onSubmit={handleSubmit(onSubmit)}>

                            <div className="row mb-3">

                                <div className="col-md-6">

                                    <label className="form-label">
                                        Project Category
                                        <span className="text-danger">*</span>
                                    </label>

                                    <select
                                        className="form-select"
                                        {...register("projectCategoryId")}
                                    >

                                        <option value="">
                                            Select Project Category
                                        </option>

                                        {projectCategories.map((p) => (

                                            <option
                                                key={p.id}
                                                value={p.id}
                                            >
                                                {p.categoryName}
                                            </option>

                                        ))}

                                    </select>

                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">
                                        Work Item Code <span className="text-danger">*</span>
                                    </label>

                                    <input
                                        type="text"
                                        maxLength={45}
                                        className="form-control"
                                        {...register("workItemCode")}
                                    />
                                </div>


                                <div className="col-md-6">

                                    <label className="form-label">
                                        Work Item Description <span className="text-danger">*</span>
                                    </label>

                                    <textarea
                                        className="form-control"
                                        maxLength={200}
                                        rows={2}
                                        {...register("workItemDescription")}
                                    />

                                </div>

                            </div>

                            <hr />

                            <h5>Work Activities</h5>

                            <table className="table table-bordered mt-2">

                                <thead>

                                    <tr>
                                        <th style={{ width: "10%" }}>Sq.No</th>

                                        <th style={{ width: "70%" }}>
                                            Activity Name
                                        </th>

                                        <th style={{ width: "45%" }}>
                                            UOM
                                        </th>

                                        <th style={{ width: "10%" }}>
                                            Active
                                        </th>

                                        <th style={{ width: "15%" }}>
                                            Action
                                        </th>

                                    </tr>

                                </thead>

                                <tbody>

                                    {activities.map((a, index) => (

                                        <tr key={index}>

                                            {/* <td>

                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Activity Name"
                                                    value={a.workActivityName}
                                                    onChange={(e) =>
                                                        handleActivityChange(
                                                            index,
                                                            e.target.value
                                                        )
                                                    }
                                                />

                                            </td> */}

                                            <td>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={a.sqNo}
                                                    onChange={(e) =>
                                                        handleActivityChange(
                                                            index,
                                                            "sqNo",
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </td>

                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Activity Name"
                                                    value={a.workActivityName}
                                                    onChange={(e) =>
                                                        handleActivityChange(
                                                            index,
                                                            "workActivityName",
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </td>

                                            <td>
                                                <select
                                                    className="form-select"
                                                    value={a.uom}
                                                    onChange={(e) =>
                                                        handleActivityChange(index, "uom", e.target.value)
                                                    }
                                                >
                                                    <option value="">Select UOM</option>

                                                    {uoms.map((uom) => (
                                                        <option key={uom.id} value={uom.uomCode}>
                                                            {uom.uomCode}
                                                        </option>
                                                    ))}
                                                </select>
                                            </td>

                                            <td className="text-center">
                                                <input
                                                    type="checkbox"
                                                    checked={a.isActive}
                                                    onChange={(e) =>
                                                        handleActivityChange(index, "isActive", e.target.checked)
                                                    }
                                                />
                                            </td>

                                            <td className="text-center">

                                                <div className="d-flex justify-content-center gap-2">

                                                    {/* ADD BUTTON */}
                                                    <button
                                                        type="button"
                                                        className="btn btn-success btn-sm"
                                                        onClick={addRow}
                                                    >
                                                        +
                                                    </button>

                                                    {/* DELETE BUTTON */}
                                                    {activities.length > 1 && (

                                                        <button
                                                            type="button"
                                                            className="btn btn-danger btn-sm"
                                                            onClick={() =>
                                                                deleteRow(index)
                                                            }
                                                        >
                                                            -
                                                        </button>

                                                    )}

                                                </div>

                                            </td>

                                        </tr>

                                    ))}

                                </tbody>

                            </table>

                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={loading}
                            >
                                {loading
                                    ? isEdit
                                        ? "Updating..."
                                        : "Saving..."
                                    : isEdit
                                        ? "Update"
                                        : "Save"}
                            </button>

                            <button
                                type="button"
                                className="btn btn-secondary ms-2"
                                onClick={() => navigate("/cpnl/workitems/view")}
                            >
                                Cancel
                            </button>

                        </form>

                    )}

                </div>
            </div>
        </>
    );
}
